import Vue from "vue";

const requireContext = require.context('./', true, /\.vue$/i) 
requireContext.keys()
    .map(file =>
        [file.replace(/(.?\/)|(\.vue$)/g, ''), requireContext(file).default]
    )
    .reduce((modules, [name, module]) => {
        if (module.namespaced === undefined) {
            module.namespaced = true
        }
        // _log_(module.name, module)

        if (module.name === undefined) {
            module.name = name
        }
        // _log_(module.name, module)

        Vue.component(module.name, module);

    }, {})